import { BehaviorSubject } from '../BehaviorSubject';
import { multicast } from './multicast';
export function publishBehavior(value) {
    return (source) => multicast(new BehaviorSubject(value))(source);
}
//# sourceMappingURL=publishBehavior.js.map